import { useEditFunctionals } from '../../hooks/useEditFunctionals';

export const EditFunctionalLvl2 = () => {
	const { getComponent } = useEditFunctionals({ isLvlOne: false });

	return getComponent();
};
